var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var App;
(function (App) {
    var Utilities = /** @class */ (function () {
        function Utilities() {
        }
        // returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // n milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.
        Utilities.debounce = function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = window.setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        };
        //HRM5 - Variant of Utilities.debounce for command buttons (lock all buttons when debouncing on one)
        Utilities.debounceForCommandButtons = function (func, wait, immediate) {
            var timeout;
            return function () {
                if ($(".command-row").attr("data-debouncing")) {
                    return;
                }
                $(".command-row").attr("data-debouncing", true);
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    $(".command-row").removeAttr("data-debouncing");
                    if (!immediate) {
                        func.apply(context, args);
                    }
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = window.setTimeout(later, wait);
                if (callNow) {
                    func.apply(context, args);
                }
            };
        };
        /**
         * Returns an object with the keys and values of comparison object, where they differ from reference object.
         * @param source The source object to compare to.
         * @param comparison The object to compare.
         */
        Utilities.objectDiff = function (source, comparison) {
            if (source === null
                || source === undefined
                || comparison === null
                || comparison === undefined) {
                return null;
            }
            var res = {};
            var any = false;
            Object.keys(comparison).forEach(function (t) {
                if (source[t] !== comparison[t]) {
                    res[t] = comparison[t];
                    any = true;
                }
            });
            return any && res || null;
        };
        Utilities.fetch = function (first, second) {
            return new Promise(function (resolve, reject) {
                $.ajax(first, second)
                    .done(function (t) { return resolve(t); })
                    .fail(function (t) { return reject(t); });
            });
        };
        /**
         * Sends an AJAX request with JSON data to an endpoint and returns a promise.
         * @param url Target endpoint URL.
         * @param data Data to send to the endpoint. May be omitted.
         * @param settings AJAX call configuration. Overrides default values.
         */
        Utilities.postJson = function (url, data, settings) {
            return Utilities.fetch(__assign({ url: url, method: "POST", dataType: "JSON", async: true, data: data }, settings));
        };
        /**
         * Gets a resource by name. Returns null if the resources does not exist.
         * @param name Resource name.
         */
        Utilities.getResource = function (name) {
            var obj = $.agito.resources.getResource(name);
            return obj || null;
        };
        return Utilities;
    }());
    App.Utilities = Utilities;
})(App || (App = {}));
var Agitavit;
(function (Agitavit) {
    /**
     * Common utilities.
     */
    var Utilities = /** @class */ (function () {
        function Utilities() {
        }
        Utilities.handleResponseMessages = function (formElement, data) {
            // check if there are any messages
            if (!data || !data.userMessages) {
                return;
            }

            // render messages
            $.agito.hrmPage.handleAjaxError(null, data);
        };
        /**
         * Returns a unique id within page. Can be used as id on html elements.
         */
        Utilities.getUniqueId = function () {
            Utilities.idCount++;
            return "ag-ctrl-id-" + Utilities.idCount.toString();
        };
        Object.defineProperty(Utilities, "selectedLanguage", {
            /**
             * Gets the users selected language.
             * @returns {}
             */
            get: function () {
                return $.agito.selectedLanguage;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Utilities, "defaultLanguage", {
            /**
             * Gets the users default language.
             * @returns {}
             */
            get: function () {
                return $.agito.defaultLanguage;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Utilities, "baseUrl", {
            /**
             * Gets the application base url.
             * @returns {}
             */
            get: function () {
                return $.agito.baseUrl;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Utilities, "currentServerCulture", {
            /**
             * Gets the current server culture.
             * @returns {}
             */
            get: function () {
                return $.agito.currentServerCulture;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Utilities, "rememberGridFilters", {
            get: function () {
                return $.agito.rememberGridFilters;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Decorator which adds an requirement to class to statically implement given interface.
         */
        Utilities.staticImplements = function () {
            return function (constructor) { };
        };
        /**
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * N milliseconds. If `immediate` is passed, trigger the function on the
         * leading edge, instead of the trailing.
         * @param func
         * @param wait
         * @param immediate
         */
        Utilities.debounce = function (func, wait, immediate) {
            return App.Utilities.debounce(func, wait, immediate);
        };
        //HRM5 - Variant of Utilities.debounce for command buttons (lock all buttons when debouncing on one)
        Utilities.debounceForCommandButtons = function (func, wait, immediate) {
            return App.Utilities.debounceForCommandButtons(func, wait, immediate);
        };
        Utilities.getEntityInstanceId = function (formChildElement) {
            var form = formChildElement.closest("form");
            if (!form) {
                return null;
            }
            var inputElement = form.querySelector("input[name='EntityInstanceId']");
            if (inputElement) {
                return inputElement.value;
            }
            return null;
        };
        Utilities.getEntityId = function (formChildElement) {
            var form = formChildElement.closest("form");
            if (!form) {
                return null;
            }
            var inputElement = form.querySelector("input[name='EntityId']");
            if (inputElement) {
                return inputElement.value;
            }
            return null;
        };
        Utilities.localizeResourceKey = function (resourceKey) {
            return $.agito.resources.getResource(resourceKey);
        };
        Utilities.openBrowserTab = function (url) {
            App.LegacyUrlHelpers.OpenBrowserTab(url);
        };
        Utilities.openQuickEditDialog = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallback, formGroupId, parameters) {
            $.agito.hrmPage.quickEditDialog(entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallback, formGroupId, parameters);
        };
        Utilities.openQuickEditDialogPost = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallback, formGroupId, parameters) {
            $.agito.hrmPage.postQuickEditDialog(entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallback, formGroupId, parameters);
        };
        Utilities.openDeleteDialog = function (entityId, entityInstanceIds, successCallback) {
            $.agito.hrmPage.openDeleteDialog(entityId, entityInstanceIds, entityInstanceIds.length, successCallback);
        };
        Utilities.idCount = 0;
        return Utilities;
    }());
    Agitavit.Utilities = Utilities;
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=utilities.js.map